import { Controller } from "stimulus";
import Roster from '../assets/scripts/roster.js'

const PLAYER_MIN = 2;
const PLAYER_MAX = 8;
const INITIAL_SCORE = 600;
const WINNING_SCORE = 1200;
let localStorage = window.localStorage;

export default class extends Controller {
  static targets = [
    "players",
    "name",
    "score"
  ]

  static classes = [
    "winner"
  ]

  initialize() {
    this.players = new Map(JSON.parse(localStorage.getItem("players")));
    this.roster = new Roster();

    this.players.forEach((score, name) => {
      this.playersTarget.appendChild(this.createRow(name, score));
    });
    this.checkForWinner();

    for (let i = this.playersTarget.childElementCount; i < PLAYER_MIN; i++) {
      this.playersTarget.appendChild(this.createRow());
    }
  }

  addPlayer() {
    if (this.playersTarget.childElementCount < PLAYER_MAX) {
      this.playersTarget.appendChild(this.createRow());
    }
  }

  checkForWinner() {
    Array.from(this.playersTarget.children).forEach(player => {
      if (
        player.lastChild.value >= WINNING_SCORE
        && player.lastChild.value == Math.max(...this.players.values())
      ) {
        player.classList.add(this.winnerClass);
      } else {
        player.classList.remove(this.winnerClass);
      }
    });
  }

  createRow(name = "", score = NaN) {
    let row = document.createElement("div");
    row.classList.add("scoreboard__player");

    let nameInput = document.createElement("input");
    const nameAttributes = {
      "type": "text",
      "placeholder": this.roster.pluck(),
      "data-scoreboard-target": "name",
      "data-action": "change->scoreboard#save"
    };
    for (const [attribute, value] of Object.entries(nameAttributes)) {
      nameInput.setAttribute(attribute, value);
    }
    nameInput.classList.add("scoreboard__name");
    nameInput.value = name || "";

    let scoreInput = document.createElement("input");
    const scoreAttributes = {
      "type": "number",
      "min": 0,
      "placeholder": INITIAL_SCORE,
      "size": 4,
      "step": 25,
      "data-scoreboard-target": "score",
      "data-action": "change->scoreboard#save change->scoreboard#checkForWinner"
    };
    for (const [attribute, value] of Object.entries(scoreAttributes)) {
      scoreInput.setAttribute(attribute, value);
    }
    scoreInput.classList.add("scoreboard__score");
    scoreInput.value = score || NaN;

    row.appendChild(nameInput);
    row.appendChild(scoreInput);
    return row;
  }

  new() {
    localStorage.removeItem("players");
    this.playersTarget.innerHTML = "";

    for (let i = this.playersTarget.childElementCount; i < PLAYER_MIN; i++) {
      this.playersTarget.appendChild(this.createRow());
    }
  }

  removePlayer() {
    if (this.playersTarget.childElementCount > 2) {
      this.playersTarget.lastChild.remove();
    }
    this.save();
  }

  save() {
    this.players.clear();
    for (let i = 0; i < this.nameTargets.length; i++) {
      if (this.nameTargets[i].value) {
        this.players.set(this.nameTargets[i].value, this.scoreTargets[i].value);
      }
    }
    localStorage.setItem("players", JSON.stringify(Array.from(this.players.entries())));
  }
}
